<div class="container">
    <ng-container *ngIf="!isMobile; else mobileHeader">
        <div class="shadow left" *ngIf="buttonsDirection === 'space-between' && currentIndex && isShowArrow"></div>
        <ng-container *ngIf="isShowArrow">
            <div class="header" *ngIf="templateHeader || buttonsDirection === 'top-right'" [ngStyle]="{ width }" [class.p-jc-end]="!templateHeader" [class.p-jc-between]="templateHeader">
                <ng-container *ngTemplateOutlet="templateHeader;"></ng-container>
                
                <ng-container *ngIf="isBtnShowAll; else moveBtns">
                    <div class="right-header">
                        <div class="show-all" (click)="shawALL()"><div class="text">Показать все </div> <img  src="assets/images/new-design-icons/Chevron Right (white).svg"/></div>
                        <ng-container *ngTemplateOutlet="moveBtns;"></ng-container>
                    </div>
                </ng-container>
                <ng-template #moveBtns>
                    <div class="buttons" *ngIf="buttonsDirection === 'top-right' && !loading && items.length">
                        <app-button [buttonClass]="'only-icon-light-gray'" (buttonClick)="prev()" [disabled]="!currentIndex" [icon]="'assets/images/new-design-icons/Arrow Left (white).svg'" [iconDirection]="'left'"></app-button>
                        <app-button [buttonClass]="'only-icon-light-gray'" (buttonClick)="next()" [disabled]="!(currentIndex + 1 < totalSlides())" [icon]="'assets/images/new-design-icons/Arrow Right (white).svg'" [iconDirection]="'left'"></app-button>
                    </div>
                    <div class="buttons" *ngIf="loading && buttonsDirection === 'top-right'"><p-progressSpinner class="spinner"  ariaLabel="loading" /></div>
                </ng-template>
            </div>
        </ng-container>
    </ng-container>

    <ng-template #mobileHeader>
        <div class="header" *ngIf="templateHeader" [class.p-jc-end]="!templateHeader" [class.p-jc-between]="templateHeader">
            <ng-container *ngTemplateOutlet="templateHeader;"></ng-container>
            <div class="show-all" *ngIf="isBtnShowAll"><div class="text" (click)="shawALL()">Показать все </div> <img  src="assets/images/new-design-icons/Chevron Right (white).svg" (click)="next()"/></div>
            <img  *ngIf="!isBtnShowAll" src="assets/images/new-design-icons/Chevron Right (white).svg" (click)="next()"/>
        </div>
    </ng-template>

    <div class="slides" [ngStyle]="{ width }">
        <ng-container *ngIf="template">
            <div class="button" *ngIf="isShowArrow && buttonsDirection === 'space-between' && currentIndex">
                <app-button  [buttonClass]="'only-icon-light-gray'" (buttonClick)="prev()" [icon]="'assets/images/new-design-icons/Arrow Left (white).svg'" [iconDirection]="'left'"></app-button>
            </div>
            <p-carousel
               [value]="items"
               [page]="currentIndex"
               [numVisible]="itemsPerSlide"
               [numScroll]="numScroll"
               [showIndicators]="false"
               [showNavigators]="false"
               [circular]="false">
                <ng-template let-item let-i="index" pTemplate="item">
                    <div class="carousel-item" >
                        <ng-container *ngTemplateOutlet="template; context: { $implicit: item, index: i }"></ng-container>
                    </div>
                </ng-template>
            </p-carousel>
            <div class="button" *ngIf="isShowArrow && buttonsDirection === 'space-between' && (currentIndex + 1 < totalSlides())">
                <app-button [buttonClass]="'only-icon-light-gray'" (buttonClick)="next()" [icon]="'assets/images/new-design-icons/Arrow Right (white).svg'" [iconDirection]="'left'"></app-button>
            </div>

        </ng-container>
    </div>
    <div class="footer" [ngClass]="{ 'right-center': buttonsDirection === 'right-center', 'right': buttonsDirection === 'bottom-right' }" *ngIf="isShowArrow && !isMobile">
        <div class="buttons mt-24" *ngIf="(buttonsDirection === 'bottom-center' || buttonsDirection === 'right-center') && !loading && items.length">
            <app-button [buttonClass]="'only-icon-light-gray'" (buttonClick)="prev()" [disabled]="!currentIndex" [icon]="'assets/images/new-design-icons/Arrow Left (white).svg'" [iconDirection]="'left'"></app-button>
            <app-button [buttonClass]="'only-icon-light-gray'" (buttonClick)="next()" [disabled]="!(currentIndex + 1 < totalSlides())" [icon]="'assets/images/new-design-icons/Arrow Right (white).svg'" [iconDirection]="'left'"></app-button>
        </div>

        <div class="buttons mt-16" *ngIf="(buttonsDirection === 'bottom-right') && !loading && items.length">
            <app-button [buttonClass]="'only-icon-light-gray'" (buttonClick)="prev()" [disabled]="!currentIndex" [icon]="'assets/images/new-design-icons/Arrow Left (white).svg'" [iconDirection]="'left'"></app-button>
            <app-button [buttonClass]="'only-icon-light-gray'" (buttonClick)="next()" [disabled]="!(currentIndex + 1 < totalSlides())" [icon]="'assets/images/new-design-icons/Arrow Right (white).svg'" [iconDirection]="'left'"></app-button>
        </div>
        <div class="buttons" *ngIf="loading && buttonsDirection === 'bottom-center'"><p-progressSpinner class="spinner"  ariaLabel="loading" /></div>
    </div>
    <div class="shadow right" *ngIf="(buttonsDirection === 'space-between' && (currentIndex + 1 < totalSlides())) && isShowArrow"></div>
</div>
